import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MenusService } from 'src/app/_services/menu.service';
import { ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridApi, GridReadyEvent, ICellRendererParams, ITooltipParams, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { UserManagementService } from '../user-management/user-management.service';
import { AlertService } from 'src/app/_services/alert.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { MerchantFilter, MerchantService } from '../reseller-setup/merchant.service';
import { CmaService } from '../cma-statement-report/cma.service';
import { SettlemtReportService } from './settlemt-report.service';
import { ModalDismissReasons, NgbDateStruct, NgbModal, NgbCalendar, NgbDateParserFormatter, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BtnCellRenderer2 } from 'src/app/common/button-cell-renderer2.component';
import { FormBuilder, FormGroup } from '@angular/forms';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const { defaultPageSizeArr, defaultPageSize } = environment;
export interface SettlementFilter {
  "pageRecords"?: number;
  "pageNumber"?: number;
  "dateFrom"?: string;
  "dateTo"?: string;
  "status"?: string;
  "processedBy"?: string;
  "senderId"?: string;
}
@Component({
  selector: 'app-settlement-report',
  templateUrl: './settlement-report.component.html',
  styleUrls: ['./settlement-report.component.scss']
})

export class SettlementReportComponent implements OnInit {
  @ViewChild('settlementModal') settlementModal: ElementRef;
  @ViewChild('confirmModal') confirmModal: ElementRef;
  @ViewChild('confirmModalReject') confirmModalReject: ElementRef;
  @ViewChild('retryModal') retryModal: ElementRef;
  currentDate: any = new Date();
  public permissions: any = '';

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public rowData: any = [];
  globalSearch: string = '';
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
  collectionSize: number = 0;
  pageRecords: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: number = 1;
  isQuickFilter: boolean = false;
  accountData: any = [];
  settlementForm: FormGroup;
  settlementData: any = [];
  collectiondata: number = 0;
  totalRecords: any;
  status: any;
  processedBy: any;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  settlementId: any;
  public columnDefs: ColDef[] = [
    {
      field: 'settlementId',
      lockVisible: true,
      headerName: 'Tranaction ID',
    },
    {
      field: 'merchantName',
      lockVisible: true,
      headerName: 'Merchant Name',
    },
    {
      field: 'merchantIdentifier',
      lockVisible: true,
      headerName: 'Merchant ID',
    },
    // {
    //   field: 'initiatedBy',
    //   lockVisible: true,
    //   headerName: 'Initiated By',
    // },
    {
      field: 'requestedDate',
      lockVisible: true,
      headerName: 'Request Date'
    },
    {
      field: 'internalCutoffTime',
      lockVisible: true,
      headerName: 'Internal Cutoff Time'
    },
    {
      field: 'currency',
      lockVisible: true,
      headerName: 'Currency',
    },
    {
      field: 'requestedAmount',
      lockVisible: true,
      headerName: 'Requested Amount',
    },
    {
      field: 'receivableAmount',
      lockVisible: true,
      headerName: 'Receivable Amount',
    },
    {
      field: 'processedBy',
      lockVisible: true,
      headerName: 'Processed By',
    },
    {
      field: 'settledOn',
      lockVisible: true,
      headerName: 'Settlement On',
      // valueFormatter: (params: any) => {
      //   // Assuming settlementOn is a timestamp or Date object
      //   return new Date(params.value).toLocaleDateString();
      // },
    },
    {
      field: 'settlementBank',
      lockVisible: true,
      headerName: 'Settlement Bank',
    },
    {
      field: 'transactionId',
      lockVisible: true,
      headerName: 'SP Trxn ID',
    },
    {
      field: 'chargesBearer',
      lockVisible: true,
      headerName: 'Charges Bearer',
    },
    {
      field: 'status',
      lockVisible: true,
      headerName: 'Status',
      cellRenderer: (params: any) => {
        const status = params.value; // Ensure case-insensitive comparison
        let badgeClass = '';
        let statusText = '';

        // Define badge class and status text based on status
        switch (status) {
          case 'SUCCESS':
            badgeClass = 'badge-success';
            statusText = 'Success';
            break;
          case 'FAILED':
            badgeClass = 'badge-danger';
            statusText = 'Failed';
            break;
          case 'PENDING':
            badgeClass = 'badge-warning';
            statusText = 'Pending';
            break;
          case 'INITIATED':
            badgeClass = 'badge-info';
            statusText = 'Initiated';
            break;
          case 'REJECTED':
            badgeClass = 'badge-danger';
            statusText = 'Rejected';
            break;
          default:
            badgeClass = '';
            statusText = '';
            break;
        }

        return `<span class="badge ${badgeClass}">${statusText}</span>`;
      }

    },
    {
      field: 'actions',
      lockVisible: true,
      headerName: 'Actions',
      width: 60,
      cellRenderer: BtnCellRenderer2,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            console.log("Row clicked :" + param.data);
            this.settlementId = param.data.settlementId;
            this.getTransactionLogsReport(param.data.settlementId)
          },
          buttonIconClass: 'icon-maximize',
          isButtonVisible: (params: ICellRendererParams) => {
            return true;
          },
          buttonClass: 'custom-button-class-black'
        },
        
        {
          clicked: async (event: any, param: any) => {
            this.settlementId = param.data.settlementId;
            this.openModal(this.confirmModal);
          },
          buttonIconClass: 'icon-check',
          isButtonVisible: (params: ICellRendererParams) => {
            const data = params.data;
            return data && (data.status === 'INITIATED' || data.status === 'initiated');
          },
          buttonClass: 'custom-button-class-black-background'
        },
        {
          clicked: async (event: any, param: any) => {
            this.settlementId = param.data.settlementId;
            this.openModalConfirm(this.confirmModalReject);
          },
          buttonIconClass: 'icon-x',
          isButtonVisible: (params: ICellRendererParams) => {
            const data = params.data;
            return data && (data.status === 'INITIATED' || data.status === 'initiated');
          },
          buttonClass: 'custom-button-class-black-background'
        },
        {
          clicked: async (event: any, param: any) => {
            this.settlementId = param.data.settlementId;
            this.openModalRetry(this.retryModal);
            // this.showEditModal(param.data);
          },
          buttonIconClass: '',
          buttonText: 'Retry',
          buttonClass: 'btn-sm',
          isButtonVisible: (params: ICellRendererParams) => {
            const data = params.data;
            return data && (data.status === 'FAILED' || data.status === 'failed') && data.retryAvailable === true;
          }
        },
      ],
    }
  ];
  internalTransactionColumnDefs: ColDef[] = [
    {
      field: 'settlementId',
      lockVisible: true,
      headerName: 'Settlement ID',
    },
    {
      field: 'sentFrom',
      headerName: 'Sent From',
    },
    {
      field: 'sentTo',
      headerName: 'Sent To',
    },
    {
      field: 'amount',
      headerName: 'Amount',
    },
    {
      field: 'transactionId',
      headerName: 'Transaction ID',
    },
    {
      field: 'transactionDate',
      headerName: 'Transaction Date',
    },
    {
      field: 'message',
      headerName: 'Message/Narration',
    },
    {
      field: 'status',
      headerName: 'Status',
      cellRenderer: (params: any) => {
        const status = params.value; // Ensure case-insensitive comparison
        let badgeClass = '';
        let statusText = '';

        // Define badge class and status text based on status
        switch (status) {
          case 'SUCCESS':
            badgeClass = 'badge-success';
            statusText = 'Success';
            break;
          case 'FAILED':
            badgeClass = 'badge-danger';
            statusText = 'Failed';
            break;
          case 'PENDING':
            badgeClass = 'badge-warning';
            statusText = 'Pending';
            break;
          case 'INITIATED':
            badgeClass = 'badge-info';
            statusText = 'Initiated';
            break;
          case 'REJECTED':
            badgeClass = 'badge-danger';
            statusText = 'Rejected';
            break;
          default:
            badgeClass = '';
            statusText = '';
            break;
        }

        return `<span class="badge ${badgeClass}">${statusText}</span>`;
      }
    }
  ];

  internalTransactionRowData: any[] = [
    // Your row data for Internal Transaction Logs here
  ];

  // Logs Grid
  logsColumnDefs: ColDef[] = [
    {
      field: 'transactionDate',
      headerName: 'Transaction Date',
    },
    {
      field: 'raisedBy',
      headerName: 'Raised By',
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
    },
    {
      field: 'remarkNarration',
      headerName: 'Remark/Narration',
    },
    {
      field: 'status',
      headerName: 'Status',
      cellRenderer: (params: any) => {
        const status = params.value; // Ensure case-insensitive comparison
        let badgeClass = '';
        let statusText = '';

        // Define badge class and status text based on status
        switch (status) {
          case 'SUCCESS':
            badgeClass = 'badge-success';
            statusText = 'Success';
            break;
          case 'FAILED':
            badgeClass = 'badge-danger';
            statusText = 'Failed';
            break;
          case 'PENDING':
            badgeClass = 'badge-warning';
            statusText = 'Pending';
            break;
          case 'INITIATED':
            badgeClass = 'badge-info';
            statusText = 'Initiated';
            break;
          case 'REJECTED':
            badgeClass = 'badge-danger';
            statusText = 'Rejected';
            break;
          default:
            badgeClass = '';
            statusText = '';
            break;
        }

        return `<span class="badge ${badgeClass}">${statusText}</span>`;
      }
    }
  ];

  logsRowData: any[] = [
    // Your row data for Logs here
  ];


  Resultdata: any;
  merchant: any;
  constructor(
    private fb: FormBuilder, 
    private router: Router, 
    private location: Location,
    private menuService: MenusService,
    private _UMS: UserManagementService, 
    private alertService: AlertService, 
    private merchantService: MerchantService, 
    private _CMS: CmaService, 
    private _SS: SettlemtReportService, 
    private modalService: NgbModal, 
    private ngbCalender: NgbCalendar, 
    private ngbDateParserFormatter: NgbDateParserFormatter
  ) {
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
  }

  async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.settlementForm = this.fb.group({
      merchant: [null],
      processedBy: [''],
      accountNumber: [null],
      status: [[]],
      searchFromDate: [''],
      searchToDate: ['']
    });
    this.merchnatList();
    this.getAccounts();
    this.getSettlementReport();
  }

  merchnatList() {
    const filter: MerchantFilter = {}
    filter.startDate = "";
    filter.endDate = "";
    this.merchantService.getMerchantList("", "", "", "", filter, "ALL", 0).subscribe((response) => {
      console.log(response);
      this.Resultdata = response.content;
    })
  }


  getAccounts() {
    this._SS.getAccounts().subscribe((res: any) => {
      this.accountData = res.response.data;
    });
  }

  getSettlementReport() {
    const filter: SettlementFilter = {}
 
 
    if (this.ngbDateParserFormatter.format(this.searchFromDate) == "" || this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00") {
      filter.dateFrom = "";
    } else {
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
 
    if (this.ngbDateParserFormatter.format(this.searchToDate) == "" || this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00") {
      filter.dateTo = "";
    } else {
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    const selectedMerchant = this.settlementForm.controls['merchant'].value;
    const processedBy = this.settlementForm.controls['processedBy'].value;
    const accountNumber = this.settlementForm.controls['accountNumber'].value;
    const status = this.settlementForm.controls['status'].value;
 
    this._SS.getSettlement(this.pageNumber - 1, this.pageRecords, filter.dateFrom, filter.dateTo, status, accountNumber, processedBy, selectedMerchant).subscribe((data: any) => {
      console.log(data.response.data.content);
      this.rowData = data.response.data.content;
      this.rowData = data.response.data.content;
      this.collectiondata = data.response.data.content
      this.collectionSize = data.response.data.totalElements
      this.totalRecords = data.response.data.totalElements
      if (data.response.data.content.length == 0) {
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
    })
  }



  onBackgroundExport() {
    const filter: SettlementFilter = {}
 
 
    if (this.ngbDateParserFormatter.format(this.searchFromDate) == "" || this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00") {
      filter.dateFrom = "";
    } else {
      filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate);
    }
 
    if (this.ngbDateParserFormatter.format(this.searchToDate) == "" || this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00") {
      filter.dateTo = "";
    } else {
      filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate);
    }
    const selectedMerchant = this.settlementForm.controls['merchant'].value;
    const processedBy = this.settlementForm.controls['processedBy'].value;
    const accountNumber = this.settlementForm.controls['accountNumber'].value;
    const status = this.settlementForm.controls['status'].value;
 
    this._SS.ExportSettlement(this.pageNumber - 1, this.pageRecords, filter.dateFrom, filter.dateTo, status, accountNumber, processedBy, selectedMerchant)
    .subscribe(
      (response: any) => {
        console.log('Background export response:', response);
        
        if (response?.response?.status === 200) {
          const referenceId = response.response.data[" document referenceId"] || response.response.data.documentReferenceId;
          const recordsCount = response.response.data.recordsCount;
          
          this.alertService.successAlertWithAcknowledgment(
            `Your export of ${recordsCount} records has started. Reference ID: ${referenceId}`
          );
        } else if (response?.response?.status === 509) {
          this.alertService.errorAlertWithMessage(
            `Export limit exceeded: ${response.response.data.message}`
          );
        } else {
          this.alertService.errorAlertWithMessage(
            response?.response?.message || "An error occurred during export. Please try again later."
          );
        }
      },
      error => {
  
        
        this.alertService.errorAlertWithMessage(
          error?.response?.message || "Failed to start background export. Please try again later."
        );
      }
    );
  }

  getTransactionLogsReport(id: string) {
    this._SS.getTransactionLogsReport(id).subscribe((data: any) => {
      console.log(data.response.data);
      this.logsRowData = [];
      this.internalTransactionRowData = [];
      this.openModal(this.settlementModal);

      this.logsRowData = data.response.data.logs.map((log: any) => ({
        settlementId: id,
        transactionDate: log.transactionDate,
        raisedBy: log.raisedBy,
        remarks: log.remarks,
        remarkNarration: log.bankNarration,
        status: log.status
      }));

      this.internalTransactionRowData = data.response.data.internalLogs.map((log: any) => ({
        settlementId: id,  // Ensure this is provided in the backend response
        sentFrom: log.sentFrom,
        sentTo: log.sentTo,
        amount: log.amount,
        transactionId: log.transactionId,
        transactionDate: log.transactionDate,
        message: log.message,
        status: log.status
      }));

      // Open the modal with data

      // If no data is found, show an alert message (optional)
      if (this.logsRowData.length === 0 && this.internalTransactionRowData.length === 0) {
        console.log("No data available");
        this.alertService.errorAlertWithMessage("No records found");
      }
    });
  }



  closeResult = '';
  openModal(content: any) {


    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private modalRef: any;
  private modalRef1: any;

  openModalConfirm(content: any) {
    this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  openModalRetry(content: any) {
    this.modalRef1 =  this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', centered: true, modalDialogClass: 'permission-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onSortChange(event: any) {
    // console.log("==Sort===>", event);
  }

  onFilterModified(param: FilterModifiedEvent | any) {
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    // console.log("onFilterOpened----->", param);
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
  }

  onPageSizeChanges(eve: any) {
    this.pageNumber = 1;
    this.getSettlementReport();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param;
    this.getSettlementReport();
  }



  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFile(): void {
    const excelFileName: string = 'settlement _report';
    this.getSettlementReport();
    let tempRec: any = [];
    tempRec = this.columnDefs.filter((col: any) => {
      const column: any = this.gridColumnApi.getColumn(col?.field);
      return column.visible && !(col?.field == "actions")
    });
    let keysToMatch: any = [];
    tempRec.map((col: any) => keysToMatch.push(col.field));
    let jsonData = this.findMatchingObjects(keysToMatch);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      header: [...tempRec.map((col: any) => col.headerName)]
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  findMatchingObjects(keys: string[]): any[] {
    let expData: any = [];
    this.rowData.forEach((curr: any) => {
      const tempRec: any = {}
      keys.forEach((col) => {
        const column: any = this.gridColumnApi.getColumn(col);
        if (column.visible) {
          tempRec[col] = curr[col];
        }
      })
      expData.push(tempRec);
    })
    return expData;
  }

  onRowClicked(param: RowClickedEvent | any) {
    // console.log("Row Clicked", param);
  }

  onRowDoubleClicked(param: RowClickedEvent | any) {
    // console.log("Row Double Clicked", param);
  }

  // Approve action triggered by modal button
  remark: any;
  approveAction(remark: string): void {
    if (remark) {
      this._SS.approveTransaction(this.settlementId, remark).subscribe(
        (res:any) => {
          if(res.response.status===200){
            this.remark="";
            this.alertService.toastSuccessMessageAlert({title:res.response.message});
            this.cancel();

          }
          else{
            this.alertService.toastErrorMessageAlert({title:res.response.message});
          }
        },
        (error) => {
          // Handle error
          console.error('Approval failed', error);
        }
      );
    }
  }

  // Reject action triggered by modal button
  rejectAction(remark: string): void {
    if (remark) {
      this.remark="";
      this._SS.rejectTransaction(this.settlementId, remark).subscribe(
        (res:any) => {
          if(res.response.status===200){
            this.alertService.toastSuccessMessageAlert({title:res.response.message});
            this.cancel1();
          }
          else{
            this.alertService.toastErrorMessageAlert({title:res.response.message});
          }
        },
        (error) => {
        
        }
      );
    }
  }

  // Retry action triggered by modal button
  retryAction(remark: string): void {
    if (remark) {
      console.log(remark)
      this._SS.retryTransaction("settlement-"+this.settlementId, remark).subscribe(
        (res:any) => {
          if(res.response.status===200){
            this.remark="";
            this.alertService.toastSuccessMessageAlert({title:res.response.message});
            this.cancel();
          }
          else{
            this.alertService.toastErrorMessageAlert({title:res.response.message});
          }
        },
        (error) => {
          // Handle error
          console.error('Retry failed', error); 
        }
      );
    }
  }

  balanceAmount: string = '';
  isBalanceVisible: boolean = false;

  toggleBalanceVisibility() {
    this.isBalanceVisible = !this.isBalanceVisible;
  }

  changeDate() {
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }


  changeEndDate() {
    this.currentDate = this.searchToDate;
    this.maxDateFrom = this.searchToDate;
  }

  selectedAccount: string;
  checkBalance() {
    if (!this.selectedAccount) {
      // Handle the case where no account is selected
      console.error('Please select an account first.');
      this.alertService.toastErrorMessageAlert({title:'Please select an account first.'}); 
      return;
    }

    this._SS.getBalance(this.selectedAccount).subscribe((response:any)=>{
      console.log(response.response.data)
        if (response.response.data.balances != null) {
          console.log(response.response.data.balances[0])
          this.balanceAmount = response.response.data.balances[0].amount;
          console.log(this.balanceAmount)
          this.toggleBalanceVisibility(); 
        }
    })
  }
  checkAccount(account:any){
    this.balanceAmount = '';
    this.isBalanceVisible = false;
  }

  cancel() {
    this.modalService.dismissAll();
    this.getSettlementReport();
  }
 
  cancel1() {
    this.modalService.dismissAll();
    this.getSettlementReport();
  }

  resetFilter(): void {
 
    this.searchFromDate = {year: 0,month: 0,day: 0,};
    this.searchToDate = {year: 0,month: 0,day: 0,};
 
    this.settlementForm.reset();
    // this.getSettlementReport();
  }
}

